import { render, staticRenderFns } from "./FaqCreate.vue?vue&type=template&id=95d6fe58&scoped=true&"
import script from "./FaqCreate.vue?vue&type=script&lang=js&"
export * from "./FaqCreate.vue?vue&type=script&lang=js&"
import style0 from "./FaqCreate.vue?vue&type=style&index=0&id=95d6fe58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95d6fe58",
  null
  
)

export default component.exports